import _defineProperty from "@babel/runtime/helpers/defineProperty";
var _defineMessages;
import { defineMessages } from 'react-intl-next';

//
// ─── INTERFACES ─────────────────────────────────────────────────────────────────
//
export var ValidationErrorMsg = /*#__PURE__*/function (ValidationErrorMsg) {
  ValidationErrorMsg["Required"] = "Required";
  ValidationErrorMsg["RequiredWithLabel"] = "RequiredWithLabel";
  ValidationErrorMsg["FormSave"] = "FormSave";
  return ValidationErrorMsg;
}({});
export var NumberValidationErrorMsg = /*#__PURE__*/function (NumberValidationErrorMsg) {
  NumberValidationErrorMsg["WholeNum"] = "WholeNum";
  NumberValidationErrorMsg["MinNum"] = "MinNum";
  NumberValidationErrorMsg["MaxNum"] = "MaxNum";
  NumberValidationErrorMsg["BetweenNum"] = "BetweenNum";
  NumberValidationErrorMsg["ExactNum"] = "ExactNum";
  NumberValidationErrorMsg["InvalidNum"] = "InvalidNum";
  return NumberValidationErrorMsg;
}({});
export var TextValidationErrorMsg = /*#__PURE__*/function (TextValidationErrorMsg) {
  TextValidationErrorMsg["MinChars"] = "MinChars";
  TextValidationErrorMsg["MaxChars"] = "MaxChars";
  TextValidationErrorMsg["BetweenChars"] = "BetweenChars";
  TextValidationErrorMsg["ExactChars"] = "ExactChars";
  TextValidationErrorMsg["MinWords"] = "MinWords";
  TextValidationErrorMsg["MaxWords"] = "MaxWords";
  TextValidationErrorMsg["BetweenWords"] = "BetweenWords";
  TextValidationErrorMsg["ExactWords"] = "ExactWords";
  TextValidationErrorMsg["RegexCustomMsg"] = "RegexCustomMsg";
  TextValidationErrorMsg["RegexDefaultMsg"] = "RegexDefaultMSg";
  TextValidationErrorMsg["RegexInvalidMsg"] = "RegexInvalidMsg";
  TextValidationErrorMsg["InvalidEmail"] = "InvalidEmail";
  TextValidationErrorMsg["InvalidUrl"] = "InvalidUrl";
  return TextValidationErrorMsg;
}({});
export var DateTimeValidationErrorMsg = /*#__PURE__*/function (DateTimeValidationErrorMsg) {
  DateTimeValidationErrorMsg["MinDate"] = "MinDate";
  DateTimeValidationErrorMsg["MaxDate"] = "MaxDate";
  DateTimeValidationErrorMsg["BetweenDate"] = "BetweenDate";
  DateTimeValidationErrorMsg["ExactDate"] = "ExactDate";
  DateTimeValidationErrorMsg["MinTime"] = "MinTime";
  DateTimeValidationErrorMsg["MaxTime"] = "MaxTime";
  DateTimeValidationErrorMsg["BetweenTime"] = "BetweenTime";
  DateTimeValidationErrorMsg["ExactTime"] = "ExactTime";
  DateTimeValidationErrorMsg["InvalidTime"] = "InvalidTime";
  DateTimeValidationErrorMsg["RequiredDateTime"] = "RequiredDateTime";
  DateTimeValidationErrorMsg["RequiredDateTimeWithLabel"] = "RequiredDateTimeWithLabel";
  DateTimeValidationErrorMsg["MinDateTime"] = "MinDateTime";
  DateTimeValidationErrorMsg["MaxDateTime"] = "MaxDateTime";
  DateTimeValidationErrorMsg["ExactDateTime"] = "ExactDateTime";
  DateTimeValidationErrorMsg["BetweenDateTime"] = "BetweenDateTime";
  return DateTimeValidationErrorMsg;
}({});
export var ChoiceValidationErrorMsg = /*#__PURE__*/function (ChoiceValidationErrorMsg) {
  ChoiceValidationErrorMsg["MinChoices"] = "MinChoices";
  ChoiceValidationErrorMsg["MaxChoices"] = "MaxChoices";
  ChoiceValidationErrorMsg["ReqChoice"] = "ReqChoice";
  ChoiceValidationErrorMsg["ExactChoices"] = "ExactChoices";
  ChoiceValidationErrorMsg["BetweenChoices"] = "BetweenChoices";
  return ChoiceValidationErrorMsg;
}({});
export var UserPickerValidationErrorMsg = /*#__PURE__*/function (UserPickerValidationErrorMsg) {
  UserPickerValidationErrorMsg["MinChoices"] = "UpMinChoices";
  UserPickerValidationErrorMsg["MaxChoices"] = "UpMaxChoices";
  UserPickerValidationErrorMsg["ExactChoices"] = "UpExactChoices";
  UserPickerValidationErrorMsg["BetweenChoices"] = "UpBetweenChoices";
  return UserPickerValidationErrorMsg;
}({});

//
// ─── MESSAGES ───────────────────────────────────────────────────────────────────
//
export var IntlValidationErrorMessages = defineMessages((_defineMessages = {}, _defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineMessages, ValidationErrorMsg.RequiredWithLabel, {
  id: 'form-system.validationErrorMsg.RequiredWithLabel',
  defaultMessage: '{fieldLabel} is required.'
}), ValidationErrorMsg.Required, {
  id: 'form-system.validationErrorMsg.Required',
  defaultMessage: 'This field is required.'
}), TextValidationErrorMsg.MinChars, {
  id: 'form-system.validationErrorMsg.text.MinChars',
  defaultMessage: 'Must be more than {mnc, plural, one {# character} other {# characters}}.'
}), TextValidationErrorMsg.MinWords, {
  id: 'form-system.validationErrorMsg.text.MinWords',
  defaultMessage: 'Must be more than {mnw, plural, one {# word} other {# words}}.'
}), TextValidationErrorMsg.MaxChars, {
  id: 'form-system.validationErrorMsg.text.MaxChars',
  defaultMessage: 'Must be less than {mxc, plural, one {# character} other {# characters}}.'
}), TextValidationErrorMsg.MaxWords, {
  id: 'form-system.validationErrorMsg.text.MaxWords',
  defaultMessage: 'Must be less than {mxw, plural, one {# word} other {# words}}.'
}), TextValidationErrorMsg.BetweenChars, {
  id: 'form-system.validationErrorMsg.text.BetweenChars',
  defaultMessage: 'Must be between {mnc} and {mxc, plural, one {# character} other {# characters}}.'
}), TextValidationErrorMsg.ExactChars, {
  id: 'form-system.validationErrorMsg.text.ExactChars',
  defaultMessage: 'Must be exactly {mnc, plural, one {# character} other {# characters}}.'
}), TextValidationErrorMsg.BetweenWords, {
  id: 'form-system.validationErrorMsg.text.BetweenWords',
  defaultMessage: 'Must be between {mnw} and {mxw, plural, one {# word} other {# words}}.'
}), TextValidationErrorMsg.ExactWords, {
  id: 'form-system.validationErrorMsg.text.ExactWords',
  defaultMessage: 'Must be exactly {mnw, plural, one {# word} other {# words}}.'
}), _defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineMessages, TextValidationErrorMsg.RegexCustomMsg, {
  id: 'form-system.validationErrorMsg.text.RegexCustomMsg',
  defaultMessage: '{message}'
}), TextValidationErrorMsg.RegexDefaultMsg, {
  id: 'form-system.validationErrorMsg.text.RegexDefaultMsg',
  defaultMessage: 'Response does not match required pattern.'
}), TextValidationErrorMsg.RegexInvalidMsg, {
  id: 'form-system.validationErrorMsg.text.RegexInvalidMsg',
  defaultMessage: 'The regex pattern on this field is invalid. Answer unable to be validated.'
}), TextValidationErrorMsg.InvalidEmail, {
  id: 'form-system.validationErrorMsg.text.InvalidEmail',
  defaultMessage: 'Must be an email address'
}), TextValidationErrorMsg.InvalidUrl, {
  id: 'form-system.validationErrorMsg.text.InvalidUrl',
  defaultMessage: 'Must be a valid URL e.g. https://www.google.com/images'
}), NumberValidationErrorMsg.InvalidNum, {
  id: 'form-system.validationErrorMsg.number.InvalidNum',
  defaultMessage: 'Please enter a valid number.'
}), NumberValidationErrorMsg.WholeNum, {
  id: 'form-system.validationErrorMsg.number.WholeNum',
  defaultMessage: 'Must be a whole number.'
}), NumberValidationErrorMsg.MinNum, {
  id: 'form-system.validationErrorMsg.number.MinNum',
  defaultMessage: 'Must be more than or equal to {mnn}.'
}), NumberValidationErrorMsg.MaxNum, {
  id: 'form-system.validationErrorMsg.number.MaxNum',
  defaultMessage: 'Must be less than or equal to {mxn}.'
}), NumberValidationErrorMsg.BetweenNum, {
  id: 'form-system.validationErrorMsg.number.BetweenNum',
  defaultMessage: 'Must be between {mnn} and {mxn}.'
}), _defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineMessages, NumberValidationErrorMsg.ExactNum, {
  id: 'form-system.validationErrorMsg.number.ExactNum',
  defaultMessage: 'Must be exactly {mnn}.'
}), DateTimeValidationErrorMsg.RequiredDateTimeWithLabel, {
  id: 'form-system.validationErrorMsg.datetime.RequiredDateTimeWithLabel',
  defaultMessage: '{fieldLabel} is required. Please specify a date and time.'
}), DateTimeValidationErrorMsg.RequiredDateTime, {
  id: 'form-system.validationErrorMsg.datetime.RequiredDateTime',
  defaultMessage: 'This field is required. Please specify a date and time.'
}), DateTimeValidationErrorMsg.ExactDateTime, {
  id: 'form-system.validationErrorMsg.datetime.ExactDateTime',
  defaultMessage: 'The date and time must be exactly the {mnd, date, medium} at {mnt, time, short}.'
}), DateTimeValidationErrorMsg.BetweenDateTime, {
  id: 'form-system.validationErrorMsg.datetime.BetweenDateTime',
  defaultMessage: 'The date and time must be between the {mnd, date, medium} at {mnt, time, short} and the {mxd, date, medium} at {mxt, time, short}.'
}), DateTimeValidationErrorMsg.MinDateTime, {
  id: 'form-system.validationErrorMsg.datetime.MinDateTime',
  defaultMessage: 'The date and time must be on or after the {mnd, date, medium} at {mnt, time, short}.'
}), DateTimeValidationErrorMsg.MaxDateTime, {
  id: 'form-system.validationErrorMsg.datetime.MaxDateTime',
  defaultMessage: 'The date and time must be on or before the {mxd, date, medium} at {mxt, time, short}.'
}), DateTimeValidationErrorMsg.MinDate, {
  id: 'form-system.validationErrorMsg.datetime.MinDate',
  defaultMessage: 'The date must be on or after {mnd, date, medium}.'
}), DateTimeValidationErrorMsg.MaxDate, {
  id: 'form-system.validationErrorMsg.datetime.MaxDate',
  defaultMessage: 'The date must be on or before {mxd, date, medium}.'
}), DateTimeValidationErrorMsg.BetweenDate, {
  id: 'form-system.validationErrorMsg.datetime.BetweenDate',
  defaultMessage: 'The date must be between {mnd, date, medium} and {mxd, date, medium}.'
}), _defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineMessages, DateTimeValidationErrorMsg.ExactDate, {
  id: 'form-system.validationErrorMsg.datetime.ExactDate',
  defaultMessage: 'The date must be exactly {mnd, date, medium}.'
}), DateTimeValidationErrorMsg.MinTime, {
  id: 'form-system.validationErrorMsg.datetime.MinTime',
  defaultMessage: 'The time must be at or after {mnt, time, short}.'
}), DateTimeValidationErrorMsg.MaxTime, {
  id: 'form-system.validationErrorMsg.datetime.MaxTime',
  defaultMessage: 'The time must be at or before {mxt, time, short}.'
}), DateTimeValidationErrorMsg.BetweenTime, {
  id: 'form-system.validationErrorMsg.datetime.BetweenTime',
  defaultMessage: 'The time must be between {mnt, time, short} and {mxt, time, short}.'
}), DateTimeValidationErrorMsg.ExactTime, {
  id: 'form-system.validationErrorMsg.datetime.ExactTime',
  defaultMessage: 'The time must be exactly {mnt, time, short}.'
}), DateTimeValidationErrorMsg.InvalidTime, {
  id: 'form-system.validationErrorMsg.datetime.InvalidTime',
  defaultMessage: 'The time is invalid.'
}), ChoiceValidationErrorMsg.ExactChoices, {
  id: 'form-system.validationErrorMsg.choice.ExactChoices',
  defaultMessage: 'Choose exactly {mns}.'
}), ChoiceValidationErrorMsg.BetweenChoices, {
  id: 'form-system.validationErrorMsg.choice.BetweenChoices',
  defaultMessage: 'Choose between {mns} and {mxs}.'
}), ChoiceValidationErrorMsg.MinChoices, {
  id: 'form-system.validationErrorMsg.choice.MinChoices',
  defaultMessage: 'Choose at least {mns}.'
}), ChoiceValidationErrorMsg.MaxChoices, {
  id: 'form-system.validationErrorMsg.choice.MaxChoices',
  defaultMessage: 'Choose no more than {mxs}.'
}), _defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineMessages, ChoiceValidationErrorMsg.ReqChoice, {
  id: 'form-system.validationErrorMsg.choice.ReqChoice',
  defaultMessage: 'The ‘{label}’ choice is required.'
}), UserPickerValidationErrorMsg.ExactChoices, {
  id: 'form-system.validationErrorMsg.userpicker.ExactChoices',
  defaultMessage: 'Choose exactly {mns, plural, one {# user} other {# users}}.'
}), UserPickerValidationErrorMsg.BetweenChoices, {
  id: 'form-system.validationErrorMsg.userpicker.BetweenChoices',
  defaultMessage: 'Choose between {mns} and {mxs, plural, one {# user} other{# users}}.'
}), UserPickerValidationErrorMsg.MinChoices, {
  id: 'form-system.validationErrorMsg.userpicker.MinChoices',
  defaultMessage: 'Choose at least {mns, plural, one {# user} other {# users}}.'
}), UserPickerValidationErrorMsg.MaxChoices, {
  id: 'form-system.validationErrorMsg.userpicker.MaxChoices',
  defaultMessage: 'Choose no more than {mxs, plural, one {# user} other {# users}}.'
})));